// QAInsightBlock — Key Insight block with headline + detail
import { useState, useEffect } from 'preact/hooks'

/**
 * Renders a key insight with headline and detail text.
 *
 * @param {Object} props
 * @param {string} props.question - The insight headline
 * @param {import('preact').ComponentChildren} props.answer - The detail JSX
 * @param {string} props.accentColor - CSS colour for gradients/accents
 * @param {number} [props.slideKey] - Changes trigger re-animation
 */
export default function QAInsightBlock({ question, answer, accentColor, slideKey }) {
  const [visible, setVisible] = useState(false)
  const [answerVisible, setAnswerVisible] = useState(false)

  // Re-animate on slide change
  useEffect(() => {
    setVisible(false)
    setAnswerVisible(false)

    const t1 = setTimeout(() => setVisible(true), 400)
    const t2 = setTimeout(() => setAnswerVisible(true), 600)

    return () => {
      clearTimeout(t1)
      clearTimeout(t2)
    }
  }, [slideKey])

  return (
    <div
      className="qa-insight"
      style={{
        '--qa-accent': accentColor,
      }}
    >
      <div className="qa-insight__glow" />
      <div
        className="qa-insight__question"
        style={{
          opacity: visible ? 1 : 0,
          transform: visible ? 'translateY(0)' : 'translateY(8px)',
          transition: 'opacity 0.3s ease, transform 0.3s ease',
        }}
      >
        <span className="qa-insight__q-marker" style={{ background: accentColor }}>Key Insight</span>
        {question}
      </div>
      <div className="qa-insight__divider" />
      <div
        className="qa-insight__answer"
        style={{
          opacity: answerVisible ? 1 : 0,
          transform: answerVisible ? 'translateY(0)' : 'translateY(8px)',
          transition: 'opacity 0.3s ease, transform 0.3s ease',
        }}
      >
        <div className="qa-insight__answer-text">{answer}</div>
      </div>
      <div className="qa-insight__bottom-glow" />
    </div>
  )
}
